import {
    REQUEST_BILLINGS_PAIDED,
    REQUEST_BILLINGS_PAIDED_FAILURE,
    REQUEST_BILLINGS_PAIDED_SUCCESS
} from "../../../constant/transaction/BillingConstant";


const initialState = {
    billingsPaided: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingsPaidedReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLINGS_PAIDED:
            return {
                ...state,
                billingsPaided: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLINGS_PAIDED_SUCCESS:
            return {
                ...state,
                billingsPaided: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLINGS_PAIDED_FAILURE:
            return {
                ...state,
                billingsPaided: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
